class QuickviewModal extends HTMLElement {
  constructor() {
    super();
    this.onclick = function () {
      this.quickView.bind(this)();
    };
  }

  quickView() {
    let quickViewModal = new bootstrap.Modal(
      document.getElementById('bonquickview-popup')
    );
    setTimeout(function () {
      quickViewModal.show();
    }, 300);

    let product_handle = $(this).data('handle'),
      section_id = $(this).data('section-id'),
      parents_block = $(this).parents('.tab-pane'),
      parents_block_id = '';

    $('#bonquickview-popup .price__regular .price-item span:first-child').text('');
    $('.product_json').text('');

    if (parents_block.length > 0) {
      parents_block_id = parents_block.attr('id');
    }

    $('#quick-view').addClass(product_handle);

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title,
        regular_price = '',
        desc = product.description,
        desc_clear = desc.replace(/(<([^>]+)>)/gi, ''),
        images = product.images,
        variants = product.variants,
        json_variants = JSON.stringify(variants),
        options = product.options,
        product_form_id =
          'product-form-' +
          product.id +
          parents_block_id +
          '_variant-quickview',
        url = '/products/' + product_handle;

      $(
        'variant-quickview > fieldset, #bonquickview-popup .swiper-slide'
      ).remove();
      $('.card-information__text a').text(title);
      $('.product_vendor').text(product.vendor);
      $('.product__description_content').html(truncate(desc_clear, 175));
      $('.bonmore, .product_url, .bonshare-item a').attr('href', url);
      $('#bonquickview-popup .product-thumbnail img').attr(
        'src',
        product.featured_image
      );

      regular_price =
        product.price % 100 == 0
          ? product.price / 100 + '.00'
          : product.price / 100;

      $('#bonquickview-popup .price__regular .price-item span:first-child').prepend(
        regular_price
      );

      $('.product_json').text(json_variants);
      $('#bonquickview-popup .product-form__input .form__label').attr(
        'for',
        'Quantity-' + section_id + parents_block_id
      );
      $('#bonquickview-popup .product-form__input .quantity__input').attr(
        'id',
        'Quantity-' + section_id + parents_block_id
      );
      $('#bonquickview-popup .product-form__input .quantity__input').attr(
        'form',
        product_form_id
      );
      $('#bonquickview-popup form').attr('id', product_form_id);

      $('#bonquickview-popup form .prod-variant-value').val(variants[0].id);

      //variants

      $('variant-quickview').attr('data-handle', product_handle);
      $('variant-quickview').attr(
        'data-section',
        product.id + parents_block_id + '_variant-quickview'
      );
      $('variant-quickview').attr('data-url', url);

      $(options).each(function (i, option) {
        let opt = option.name;
        $('variant-quickview').prepend(
          `<fieldset class="js product-form__input">
            <legend class="form__label">${opt}:</legend>          
            </fieldset>`
        );
      });

      $(options).each(function (i, option) {
        let opt = option.name;

        $(option.values).each(function (i, value) {
          value = value.replace(' ', '');
          let checked = '';
          if (i == 0) {
            checked = 'checked';
          }
          let label = '';

          if (opt == 'Color') {
            label = `<label class="color" for="bonatribute-js-${product.id}-${option.position}-${i}-${parents_block_id}" style="background-color: ${value}">&nbsp</label>`;
          } else {
            label = `<label for="bonatribute-js-${product.id}-${option.position}-${i}-${parents_block_id}">${value}</label>`;
          }

          $('variant-quickview > .product-form__input').each(function (j) {
            if (option.position == j + 1) {
              $(this).append(
                `<input type="radio" id="bonatribute-js-${product.id}-${option.position}-${i}-${parents_block_id}"
                name="${opt}__${product.id}"
                value='${value}'
                form="${product_form_id}"
                ${checked}>
                ${label}
                `
              );
            }
          });
        });
      });

      // images

      $(images).each(function (i, image) {
        let new_image = image
          .replace('.jpg', '_800x.jpg')
          .replace('.png', '_800x.png');

        var image_item =
          '<li class="swiper-slide {% if forloop.index0 == 0 %}active{% endif %}"><div class="bonthumbnails-img-quick" data-href="' +
          new_image +
          '"><img src="' +
          new_image +
          'loading="lazy" alt="' +
          title +
          '" title="' +
          title +
          '" /></div></li>';
        $('.quickview__gallery-thumbnails .bonthumbnails').append(image_item);
      });

      // slider

      var swiper_quickview = new Swiper('.quickview__gallery-thumbnails', {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 3,
        autoHeight: true,
        mousewheel: true,
        direction: 'vertical',
        navigation: {
          nextEl: '.bonswiper-button-next',
          prevEl: '.bonswiper-button-prev'
        }
      });
    });

    function truncate(string, limit) {
      return string.length > limit ? `${string.substr(0, limit)}...` : string;
    }
  }
}

customElements.define('quickview-open', QuickviewModal);

$(document).ready(function () {
  $(document).on('click', '.bonthumbnails-img-quick', function (e) {
    var urlThumbnails = $(this).attr('data-href');
    var boxThumbnails = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .children('.product-thumbnail')
      .find('img');
    $(boxThumbnails).attr('srcset', urlThumbnails);
    $(this).parent().parent().find('li.active').removeClass('active');
    $(this).parent().addClass('active');
  });
});
